import SelectOrganizationPage from "./selectOrganization";

export default SelectOrganizationPage;